import { useEffect, useRef, useState } from "react";
import { ReasonCodesViewModel } from "../../../viewmodels/setup/reasonCodes/ReasonCodesViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter } from "../../../shared/utility";

import SlideOver from "../../../components/slideOver/SlideOver";
import EmptyModal from "../../../components/modals/EmptyModal";

import { Paginator } from "primereact/paginator";
import TableLoadingSkeleton from "../../../components/shared/TableLoadingSkeleton";
import AuditActionLink from "../../../components/audit/AuditActionLink";
import AuditHistoriesLink from "../../../components/audit/AuditHistoriesLink";

import Button from "../../../components/controls/Button";

function ReasonCodes(props) {
  const { addSnackbar, logout } = props;
  const {
    openAddReasonCodeSlideOver,
    getReasonCodes,
    loading,
    reasonCodes,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDeleteReasonCode,
  } = ReasonCodesViewModel(logout, addSnackbar);

  var currentPage = 1;
  useEffect(() => {
    getReasonCodes(null, currentPage);
  }, []);

  const searchRef = useRef();

  const handleSearch = () => {
    getReasonCodes(searchRef.current.value, currentPage);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getReasonCodes(searchRef.current.value, currentPage);
  };

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);

  return (
    <div>
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Reason Codes
              </h1>
              <div className="mt-5 flex rounded-md">
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                  <input
                    type="search"
                    name="searchInput"
                    id="searchInput"
                    className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                    placeholder="Search by name"
                    ref={searchRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleSearch();
                    }}
                  />
                </div>
                <button
                  type="button"
                  className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                  onClick={() => handleSearch()}
                >
                  <MagnifyingGlassIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </button>
                <Button className="ml-5" onClick={() => openAddReasonCodeSlideOver(false, null, null)}>Add Reason Code</Button>
                <AuditHistoriesLink slug="reason-code" />
              </div>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                {loading ? (

                  <TableLoadingSkeleton rows={5} columns={4} />

                ) : (
                  <div className="overflow-hidden card-custom">
                    <table className="min-w-full divide-y divide-gray-300">
                      <thead className="bg-white">
                        <tr>
                          <th
                            scope="col"
                            className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                          >
                            Name
                          </th>
                          <th
                            scope="col"
                            className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                          ></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {reasonCodes.data.map((reasonCode, index) => (
                          <tr key={reasonCode.id}>
                            <td className="whitespace-nowrap py-1.5 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                              {reasonCode.name}
                            </td>
                            <td className="relative whitespace-nowrap py-1.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                              <Button
                                onClick={() => {
                                  openAddReasonCodeSlideOver(
                                    true,
                                    reasonCode,
                                    index
                                  );
                                }}
                              >
                                Edit
                              </Button>
                              <Button
                                className="ml-2"
                                variant="danger"
                                onClick={() => {
                                  askDeleteReasonCode(reasonCode, index);
                                }}
                              >
                                Delete
                              </Button>
                              <AuditActionLink slug="reason-code" id={reasonCode.id} name={reasonCode.name} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className="w-full">
                  <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={reasonCodes.total}
                    onPageChange={handlePagination}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReasonCodes)
);
